__turbopack_context__.v({
  "deleteBtn": "imageSwiper-module-scss-module__Q_pKlW__deleteBtn",
  "dot": "imageSwiper-module-scss-module__Q_pKlW__dot",
  "dotActive": "imageSwiper-module-scss-module__Q_pKlW__dotActive",
  "dots": "imageSwiper-module-scss-module__Q_pKlW__dots",
  "img": "imageSwiper-module-scss-module__Q_pKlW__img",
  "lightboxClose": "imageSwiper-module-scss-module__Q_pKlW__lightboxClose",
  "lightboxImg": "imageSwiper-module-scss-module__Q_pKlW__lightboxImg",
  "lightboxOverlay": "imageSwiper-module-scss-module__Q_pKlW__lightboxOverlay",
  "navBtn": "imageSwiper-module-scss-module__Q_pKlW__navBtn",
  "navNext": "imageSwiper-module-scss-module__Q_pKlW__navNext",
  "navPrev": "imageSwiper-module-scss-module__Q_pKlW__navPrev",
  "slide": "imageSwiper-module-scss-module__Q_pKlW__slide",
  "track": "imageSwiper-module-scss-module__Q_pKlW__track",
  "wrap": "imageSwiper-module-scss-module__Q_pKlW__wrap",
});
